import _isNil from 'lodash/isNil';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@Components/Button/Button';
import CircularLoading from '@Components/CircularLoading/CircularLoading';
import Styles from '@Components/Settings/views/SettingsViews.scss';
import FilesApi from '@Data/files/Api';
import { selectedProjectState } from '@Data/projects/Reducer';
import { ISettingsBaseComponentProps } from '../../Interfaces';

export const ProjectAutoQcConfig = (props: ISettingsBaseComponentProps) => {
    const { title, id } = props;
    const selectedProject = useSelector(selectedProjectState);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);

    const handleDownloadMasterCatalogue = () => {
        setIsDownloading(true);

        FilesApi.getAutoQcMasterCatalogue(`AutoQcMasterCatalogue.json`, () => {
            setIsDownloading(false);
        });
    };

    const handleDownloadProjectConfig = () => {
        setIsDownloading(true);

        const projectId = selectedProject.project_id;
        console.log(`Getting Auto QC config for ${projectId}`);

        FilesApi.getProjectAutoQcConfig(
            projectId,
            `ProjectConfig_${projectId}.json`,
            () => {
                setIsDownloading(false);
            }
        );
    };

    const handleUpdateConfig = async () => {
        if (file) {
            const projectId = selectedProject.project_id;
            console.log(
                `Getting Auto QC config for ${projectId} from ${file.name}`
            );
            const config_string = await file.text();
            const config = JSON.parse(config_string);

            setIsUpdating(true);
            FilesApi.updateProjectAutoQcConfig(projectId, config, () => {
                setIsUpdating(false);
                alert(`Updated Config for project id ${projectId}`);
            });
        }
    };

    let innerHtml = <></>;

    if (!isLoading) {
        innerHtml = _isNil(selectedProject) ? (
            <>
                <span>Loading Project Details...</span>
                <div>
                    <CircularLoading />
                </div>
            </>
        ) : (
            <>
                <Button
                    color="blue"
                    onClick={() => handleDownloadMasterCatalogue()}
                >
                    Download Template
                </Button>
                <Button
                    color="blue"
                    onClick={() => handleDownloadProjectConfig()}
                >
                    Download Config
                </Button>
                <span>
                    <input
                        type="file"
                        onChange={(e) => {
                            const filename = e.target.files[0].name;
                            console.log(`file selected ${filename}`);
                            setFile(e.target.files[0]);
                        }}
                    ></input>
                    <Button color="blue" onClick={() => handleUpdateConfig()}>
                        Update Config
                    </Button>
                </span>
            </>
        );
    }

    return (
        <div className={Styles.condensedSettingsViewWrapper}>
            <div className={Styles.settingsViewHeader}>
                <span id={`${id}-title`}>{title}</span>
            </div>

            <div className={Styles.condensedSettingsViewWrapper}>
                {innerHtml}
            </div>
        </div>
    );
};
